import {useSnackbar} from 'notistack';
import * as R from 'ramda';
import React from 'react';
import {ICardData} from '../../CommonInterfaces/Form';
import {BackButton} from '../../Components/Buttons/BackButton';
import {CardContainer} from '../../Components/CardContainer/CardContainer';
import {CreateAndUpdateForm} from '../../Components/FormGenerators/CreateAndUpdateForm';
import {IEditableSchool} from '../../Components/FormGenerators/IEditableSchool';
import {
  entityTagsArrayToObject,
  removeLastEmptyEntityTag,
} from '../../Components/FormGenerators/Inputs/SubjectClassField/EntityTag';
import {RowOfButtons} from '../../Components/Layout/RowOfButtons';
import PageTitle from '../../Components/PageTitle/PageTitle';
import RedirectTo404 from '../../Components/RedirectTo404';
import {IPageInterface} from '../entity/IPageInterface';
import {
  SchoolEntity,
  useGetEntityDetails,
} from '../entity/useGetEntityDetails';
import {SchoolUpdateFields} from './SchoolFields';

/**
 * School's update card.
 * @param {string | undefined} id
 * @return {JSX.Element}
 * @constructor
 */
export default function SchoolUpdateCard({id}: IPageInterface) {
  const emptyEntity: ICardData = {};
  const {data, isError} = useGetEntityDetails<IEditableSchool>(
    SchoolEntity.name,
    id as string,
    emptyEntity as unknown as IEditableSchool,
    entityTagsArrayToObject);

  const {enqueueSnackbar} = useSnackbar();

  return (
    <React.Fragment>
      <RedirectTo404 isError={isError}/>

      {data && !R.isEmpty(data) ? <PageTitle
        title={`Изменение организации ${data.name_short}`}
      /> : null}

      <RowOfButtons>
        <BackButton/>
      </RowOfButtons>

      {
        !R.isEmpty(data) ?
          <CardContainer>
            <CreateAndUpdateForm<IEditableSchool>
              action={'SCHOOL_UPDATE'}
              id={id}
              fields={SchoolUpdateFields}
              data={data as unknown as IEditableSchool}
              snackBar={enqueueSnackbar}
              preProcessData={removeLastEmptyEntityTag}
            />
          </CardContainer> :
          null
      }

    </React.Fragment>
  );
}
